import React from "react";
import { Box, Grid, Typography, Paper, Container } from "@mui/material";
import imgUrl from "../../assets/images/imgUrl";

const campusPeace = [
 
      <>
        <b>Contribution -  </b> <br />
       
          USD 21
       
       per registered member (one-time only). 
  
   </>,
      <>
        <b>Eligibility -  </b> <br></br> At least 40% of organisational members, staff or volunteers enrolled. 
      </>,
   
      <>
        {" "}
        <b>Goal -  </b> <br></br> Empower values, strengthen communities and elevate collective impact for humanity. 
      </>,
   
   
      <>
        <b>Global reach - </b> <br></br> Partnerships extend across all continents, uniting organisations into one Global voice. 
      </>
    
];

const campusPeaceCorporate = [
 
      <>
        <b>Contribution -  </b> <br />
       
         USD 21
per employee (one‑time only).
  
   </>,
      <>
        <b>Eligibility -  </b> <br></br> At least
40%
of workforce
enrolled.
      </>,
   
      <>
        {" "}
        <b>Goal -  </b> <br></br> Empower values,
elevate brand,
uplift humanity.
      </>,
   
   
      <>
        <b>Global reach - </b> <br></br> across all continents.
      </>
    
];

const programIncludes = [
  <>
   
      {" "}
      Inspire unity and trust across NGOs, foundations and civil society bodies. 
  </>,
  <>
   	Promote dignity, inclusion and harmonious cooperation in communities. 
  </>,
  <>
      Strengthen organisational resilience and the well-being of members. 
  </>,
  <>
    {" "}
    Create measurable, positive impact that uplifts humanity across the globe. 
  </>,
  <>
    	Align with a non-religious, non-political Global movement for Justice, Love & Peace.
  </>,
  <>
    Gain recognition <br></br> through Global platforms, events and advocacy campaigns. 
  </>,
  <>
    Receive  official <br></br> <b>I Am Peacekeeper Organisations Certificate</b> as a mark of partnership. 
  </>,
];

const programIncludesCorporate = [
  <>
   
      {" "}
      Inspire unity,
trust and
collaboration across teams.
  </>,
  <>
   	Promote
human dignity and
harmonious
workplaces.
  </>,
  <>
      Strengthen
well-being
and emotional resilience.
  </>,
  <>
    {" "}
    Create
measurable
positive impact
across the Globe.
  </>,
  <>
    	Align with a
non-religious,
non-political Global
movement.
  </>,
  <>
    Enhance brand <br></br>
presence 
through Global <br></br> events
and recognition.
  </>,
  <>
    Receive official
<i> I Am Peacekeeper </i> Corporates partnership <br></br> certification.
  </>,
];

const sdgs = [
  {
    title: "SDG 16",
    subtitle: " Peace, Justice & Strong Institutions",
    description: (
      <>
        Build an inclusive world <br></br> rooted in justice, love & <br></br>{" "}
        peace.
      </>
    ),

    icon: imgUrl.sdg16Icon,
  },
  {
    title: "SDG 4",
    subtitle: " Quality Education",
    description: (
      <>
        Teach 7 Human Values <br></br>
        through employee <br></br>
        learning sessions.
      </>
    ),
    icon: imgUrl.sdg4Icon,
  },
  {
    title: "SDG 3",
    subtitle: "Reduced Inequalities",
    description: (
      <>
        Bridge cultures and <br></br> countries through unity.
      </>
    ),
    icon: imgUrl.sdg10Icon,
  },
  {
    title: "SDG 3",
    subtitle: "Good Health & Wellbeing",
    description: (
      <>
        Support mental and <br></br>
        emotional wellness in the <br></br>
        workplace.
      </>
    ),
    icon: imgUrl.sdg3Icon,
  },
  {
    title: "SDG 5",
    subtitle: "Gender Equality",
    description: (
      <>
        Promote dignity, equality <br></br> and respect across teams.
      </>
    ),
    icon: imgUrl.sdg5Icon,
  },
  {
    title: "SDG 17",
    subtitle: (
      <>
        Partnerships <br></br> for the Goals
      </>
    ),
    description: (
      <>
        Collaborate with global <br></br> partners to create impact.
      </>
    ),
    icon: imgUrl.sdg17Icon,
  },
];

const whatYouReceive = [
  <>
  	An official <b> I Am <br></br> Peacekeeper Organisations  Certificate.</b>
  </>,
  <>
   Global listing on official I Am Peacekeeper Movement <br></br> websites. 
  </>,
  <>
    	Recognition and visibility across continents. 
  </>,
  <>
    <b>	I Am Peacekeeper Courses </b> (online) for members of the Movement. 
  </>,
  <>
   	Invitations to the Dubai <i>I Am Peacekeeper Charter <br></br> Launch. </i> 
  </>,
  <>
    Strategic reports <br></br> and thought-leadership insights for boards and trustees.
  </>,
  <>
   Access to Global Summits and Conclaves. 
  </>,
  <>
    Opportunities to engage in international advocacy campaigns. 
  </>,
  <>
    Media coverage, including features and interviews. 
  </>,
  <>
    	Dialogues with Nobel Peace Laureates and Global leaders. 
  </>,
  <>
      Co-branding opportunities on select peace initiatives. 
  </>,
  <>
    Reserved access to networking sessions and cultural gatherings.


  </>
];

const whatYouReceiveCorporates = [
  <>
  <i>	I Am
Peacekeeper  </i>
Corporates
Certificate.
  </>,
  <>
   Global listing on
<i>I Am Peacekeeper
Movement </i>
websites.
  </>,
  <>
    	A Global presence
spanning every
continent.
  </>,
  <>
   Annual Employee
Value Workshops
(online).
  </>,
  <>
   	Visibility at the <i>
Dubai I Am Peacekeeper </i>
Charter Launch.
  </>,
  <>
    Strategic reports
and insights for leadership.
  </>,
  <>
   Access to Global Summits and Conclaves. 
  </>,
  <>
    Access to international
advocacy campaigns.
  </>,
  <>
    Media coverage and
interview opportunities.
  </>,
  <>
    Preferential seating at Events
and Gala Dinners.
  </>,
  <>
      Invitations to
networking with Nobel Peace Laureates.
  </>,
  <>
   Co‑branding opportunities
on select movement initiatives.


  </>
];

const buildLegacy = [
  {
    text: (
      <>
        Become a purpose - <br></br> driven company that <br></br> inspires
        employees, <br></br> clients and 
        <br></br> communities.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        <b> Act Now. </b> <br></br>
        <b> Make History</b>
      </>
    ),

    colorClass: "gradient-yellow",
  },
    {
    text: (
      <>
        Join one of the world’s <br></br> fastest growing Peace Movements.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Build a lasting legacy <br></br>
        of Justice, Love & Peace.
      </>
    ),

    colorClass: "gradient-yellow",
  },
];

const anchoringMovement = [
  {
    text: (
      <>
        Every organisation adds strength to the Global legacy of Justice, Love & Peace.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Together, NGOs and foundations can model values-based leadership for humanity.
      </>
    ),

    colorClass: "gradient-yellow",
  },
    {
    text: (
      <>
        Anchored in the <b>28 Gems of World Peace </b> , including the <b> 7 Human Values, </b> this programme unites purpose with action.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Act now, make history and become part of one of the world’s fastest-growing Global movements.
      </>
    ),

    colorClass: "gradient-yellow",
  },
];

const CampusBeconCard = ({ text, colorClass }) => (
  <Paper
    elevation={3}
    className={`gradientCard ${colorClass}`}
    sx={{
      width: 180,
      height: 180,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 2,
      m: "auto",
    }}
  >
    <Typography variant="body2">{text}</Typography>
  </Paper>
);

const ProgramCard = ({ text }) => (
  <Paper elevation={3} className="CircleCard">
    <Typography variant="body2">{text}</Typography>
  </Paper>
);

const ReceiveCard = ({ text }) => (
  <Paper elevation={3} className="CircleCard ReceiveCard">
    <Typography variant="body2">{text}</Typography>
  </Paper>
);


const InfoCard = ({ text }) => (
  <Paper elevation={3} className="infoCard">
    <Typography variant="body2">{text}</Typography>
  </Paper>
);

const OrganisationsCorporate = () => {
  return (
    <>
      {/* Organization Hero Background Section */}
      <Box
        className="programOrgSectionBg commonBannerBg"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          color: "white",
          px: 2,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 80,
            left: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
        </Box>
      </Box>



      {/* Main Organization section */}
      <Box
        mt={5}
        className="d-flex-align-center-justify-center w-100 flex-direction-column"
      >
        {/* Main Heading */}
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid
            item
            xs={12}
            className="d-flex-align-center-justify-center w-100 flex-direction-column"
          >
            <img
              src={imgUrl.peaceIcon}
              className="w-100 peaceImg"
              alt="Peacekeeper Icon"
            />
            <Typography variant="h5" className="founder-title mainHeading green-title">
            <i>  I Am Peacekeeper </i> Organisations
            </Typography>
          </Grid>
        </Grid>
         <Box className="schoolProgramMainSection">
          <Container className="paddingSubContainer programCardContainer mt-30px">
            <Grid
              container
              spacing={2}
              mt={1}
              justifyContent="center"
              alignItems="center"
              display="flex"
            >
              {campusPeace.map((text, index) => (
                           <Grid size={{ xs: 12, md: 3, sm: 6 }} key={index}>
                             <InfoCard text={text} 
                              />
                           </Grid>
                         ))}
            </Grid>
          </Container>
        </Box>

        {/* peeceKeeper Corporate */}
        {/* Program Includes Section */}
        <Box mt={5} className="programCardMain corporateMainSection mt-50px">
          <Typography
            variant="h5"
            align="center"
            fontWeight="bold"
            gutterBottom
            className="subHeading mb-0px"
          >
            Why Join?
          </Typography>
          {/* <p align="center">
            Your organization’s partnership directly supports your Corporate
            Social <br></br> Responsibility (CSR) goals
          </p> */}

          <Container className="paddingSubContainer programCardContainer mt-30px">
            <Grid
              container
              spacing={2}
              mt={1}
              justifyContent="center"
              alignItems="center"
              display="flex"
            >
              {programIncludes.map((text, index) => (
                <Grid
                  size={{ xs: 12, md: 3, sm: 4 }}
                  key={index}
                  justifyContent="center"
                  alignItems="center"
                  display="flex"
                >
                  <ProgramCard text={text} />
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

      

        {/*  WHAT YOU RECEIVE? section */}
        <Box mt={5} className="schoolProgramMainSection waveBg mt-50px">
          <Typography
            variant="h5"
            align="center"
            fontWeight="bold"
            gutterBottom
            className="subHeading mb-0px"
          >
            What You Receive?
          </Typography>

          <Container className="paddingSubContainer mt-50px">
            <Grid
              container
              spacing={2}
              mt={1}
              justifyContent="center"
              alignItems="center"
              display="flex"
            >
              {whatYouReceive.map((text, index) => (
                <Grid
                  size={{ xs: 12, md: 3, sm: 6 }}
                  key={index}
                 
                >
                  <InfoCard text={text} />
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

        {/* LET’S BUILD A LEGACY OF JUSTICE, LOVE & PEACE Section */}
           <Box mt={5} className="campusPeaceSection mt-50px">
          <Typography
            variant="h5"
            align="center"
            fontWeight="bold"
            gutterBottom
            className="subHeading mb-0px"
          >
            Anchoring the Movement
          </Typography>

          <Container className="paddingContainer mt-50px">
            <Grid container spacing={5} justifyContent="center" mb={4}>
              {anchoringMovement.map(({ text, colorClass }, index) => (
                <Grid size={{ xs: 12, sm: 4, md: 3 }} key={index}>
                  <CampusBeconCard text={text} colorClass={colorClass} />
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>
      </Box>

      
      {/* corporates section */}
      <Box>
        {/* Main Heading */}
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid
            item
            xs={12}
            className="d-flex-align-center-justify-center w-100 flex-direction-column"
          >
            <img
              src={imgUrl.peaceIcon}
              className="w-100 peaceImg"
              alt="Peacekeeper Icon"
            />
            <Typography variant="h5" className="founder-title mainHeading green-title">
             <i>I Am Peacekeeper </i>  Corporates
            </Typography>
          </Grid>
        </Grid>

        <Box className="schoolProgramMainSection mt-50px">
          <Container className="paddingSubContainer programCardContainer mt-30px">
            <Grid
              container
              spacing={2}
              mt={1}
              justifyContent="center"
              alignItems="center"
              display="flex"
            >
              {campusPeaceCorporate.map((text, index) => (
                           <Grid size={{ xs: 12, md: 3, sm: 6 }} key={index}>
                             <InfoCard text={text} 
                              />
                           </Grid>
                         ))}
            </Grid>
          </Container>
        </Box>

        {/* peeceKeeper Corporate */}
        {/* Program Includes Section */}
        <Box mt={5} className="programCardMain corporateMainSection mt-50px">
          <Typography
            variant="h5"
            align="center"
            fontWeight="bold"
            gutterBottom
            className="subHeading mb-0px"
          >
            Why Join?
          </Typography>
          {/* <p align="center">
            Your organization’s partnership directly supports your Corporate
            Social <br></br> Responsibility (CSR) goals
          </p> */}

          <Container className="paddingSubContainer programCardContainer mt-30px">
            <Grid
              container
              spacing={2}
              mt={1}
              justifyContent="center"
              alignItems="center"
              display="flex"
            >
              {programIncludesCorporate.map((text, index) => (
                <Grid
                  size={{ xs: 12, md: 3, sm: 4 }}
                  key={index}
                  justifyContent="center"
                  alignItems="center"
                  display="flex"
                >
                  <ProgramCard text={text} />
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

      

        {/*  WHAT YOU RECEIVE? section */}
        <Box mt={5} className="schoolProgramMainSection waveBg mt-50px">
          <Typography
            variant="h5"
            align="center"
            fontWeight="bold"
            gutterBottom
            className="subHeading mb-0px"
          >
            What You Receive ?
          </Typography>

          <Container className="paddingSubContainer mt-50px">
            <Grid
              container
              spacing={2}
              mt={1}
              justifyContent="center"
              alignItems="center"
              display="flex"
            >
              {whatYouReceiveCorporates.map((text, index) => (
                <Grid
                  size={{ xs: 12, md: 3, sm: 6 }}
                  key={index}
                 
                >
                  <InfoCard text={text} />
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

        {/* anchoring the movement */}
        <Box mt={5} className="campusPeaceSection mt-50px">
          <Typography
            variant="h5"
            align="center"
            fontWeight="bold"
            gutterBottom
            className="subHeading mb-0px"
          >
            Anchoring the Movement
          </Typography>

          <Container className="paddingContainer mt-50px">
            <Grid container spacing={5} justifyContent="center" mb={4}>
              {anchoringMovement.map(({ text, colorClass }, index) => (
                <Grid size={{ xs: 12, sm: 4, md: 3 }} key={index}>
                  <CampusBeconCard text={text} colorClass={colorClass} />
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

          {/* united nation section */}
        <Box className="sdgSection sdgOrgSection" mt={3}>
          <Typography
            variant="h5"
            align="center"
            fontWeight="bold"
            gutterBottom
            className="subHeading"
          >
            We Align With 6 United Nations SDGS
          </Typography>

          <Container className="paddingSubContainer">
            <Grid
              container
              spacing={3}
              justifyContent="center"
              className="sdgGrid"
            >
              {sdgs.map((item, index) => (
                <Grid
                  size={{ xs: 12, sm: 4, md: 4 }}
                  key={index}
                  className="d-flex-align-center-justify-center sdgMainCard"
                >
                  <Box className="sdgCard">
                    <img src={item.icon} alt={item.title} className="sdgIcon" />
                    <div></div>
                    <div>
                      <Typography
                        variant="subtitle2"
                        fontWeight="bold"
                        className="sdgTitle"
                      >
                        {item.title}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        fontWeight="bold"
                        className="sdgTitle sdgSubTitle"
                      >
                        {item.subtitle}
                      </Typography>
                      <Typography variant="body2" className="sdgDescription">
                        {item.description}
                      </Typography>
                    </div>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default OrganisationsCorporate;
